import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import LipPiercingImage from '../../Assets/Piercing Services/lip piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function LipPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Lip Piercing UAE | 150-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Lip Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Lip Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={LipPiercingImage} alt="Lip Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Lip Piercing</h3>

          <p>
            Enhance your style with our professional lip piercing services in the UAE, available at an affordable price range of 150–200 AED. Lip piercing is a versatile and trendy facial piercing that allows you to express your individuality with confidence and creativity. Whether you prefer a subtle stud for a clean and minimal look or a stylish ring for a bold statement, lip piercing offers endless possibilities to match your personal style. Suitable for various placements such as the lower lip, upper lip, or side lip, this piercing is a popular choice for those who want a modern and fashionable appearance. Our expert specialists ensure precise placement for a balanced and aesthetically pleasing result that enhances your facial features.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each lip piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Lip piercings require special attention due to the sensitivity of the area, and our experienced specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible.
          </p>

          <p>
            Lip piercing is ideal for individuals who want a stylish and expressive look that stands out. It can be customized to suit your preferences, whether you are going for a subtle, elegant vibe or a bold, edgy style. This piercing pairs well with other facial or ear piercings, allowing you to create a unique and personalized aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your face shape and desired look.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that facial piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your lip piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our lip piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted lip piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a stylish and versatile look effortlessly. Book your lip piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Lip Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LipPiercing;